import './components/accordion'

(function () {
    const body = document.body;

    /**
     * Remove preload class
     */
    window.addEventListener('load', function () {
        body.classList.remove('preload');
    });


    /**
     * Navigation toggle
     */
    document.addEventListener('DOMContentLoaded', function () {
        const navToggle = document.getElementById('btn-nav-toggle');
        const body = document.body;
        const html = document.documentElement;
        const bodyOverlay = document.querySelector('.body-overlay'); // Select the overlay

        if (!navToggle || !bodyOverlay) return;

        function closeMenu() {
            body.classList.remove('has-nav-open');
            body.classList.add('has-nav-closed');
            navToggle.classList.remove('is-active');
            navToggle.setAttribute('aria-expanded', 'false');
            html.style.overflow = ''; // Restore scrolling
        }

        navToggle.addEventListener('click', function () {
            const hasNavOpen = body.classList.contains('has-nav-open');

            body.classList.toggle('has-nav-open', !hasNavOpen);
            body.classList.toggle('has-nav-closed', hasNavOpen);
            this.toggleAttribute('aria-expanded', !hasNavOpen);

            html.style.overflow = hasNavOpen ? '' : 'hidden'; // Manage page scrolling
        });

        // Close menu when clicking on overlay
        bodyOverlay.addEventListener('click', closeMenu);
    });


    /**
     * Submenu toggle
     */
    document.querySelectorAll('.submenu-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            const parent = this.parentElement;
            if (parent.classList.contains('dropdown-active')) {
                parent.classList.toggle('dropdown-active');
            } else {
                parent.classList.toggle('dropdown-active');
                var siblings = parent.parentElement.children;
                Array.prototype.forEach.call(siblings, function (sibling) {
                    if (sibling !== parent) {
                        sibling.classList.remove('dropdown-active');
                    }
                });
            }
        });
    });


    /**
     * Attaches a click event listener to all anchor links that start with "#".
     * Prevents default anchor behavior and smoothly scrolls to the target section.
     */
    document.querySelectorAll('a[href]').forEach(anchor => {
        anchor.addEventListener('click', function (event) {
            const href = this.getAttribute('href');
            const hashIndex = href.indexOf("#");

            if (hashIndex === -1) return; // No anchor

            const basePath = href.substring(0, hashIndex); // e.g., "/team"
            const hash = href.substring(hashIndex);        // e.g., "#work"
            const currentPath = window.location.pathname;

            // Only apply smooth scroll if link is on current page
            if (basePath && basePath !== currentPath) {
                return; // Link is for another page — let browser handle it
            }

            const targetElement = document.querySelector(hash);
            if (targetElement) {
                const extraMargin = 40;
                const targetPosition = targetElement.offsetTop - extraMargin;
                smoothScrollTo(targetPosition, 1000); // Adjust speed as needed
            }
        });
    });

    window.addEventListener('load', () => {
        const hash = window.location.hash;
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                targetElement.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        }
    });

    function smoothScrollTo(targetPosition, duration) {
        const startPosition = window.scrollY;
        const distance = targetPosition - startPosition;
        const startTime = performance.now();

        function animation(currentTime) {
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const easedProgress = easeInOutQuad(progress); // Ease-in-out effect

            window.scrollTo(0, startPosition + distance * easedProgress);

            if (timeElapsed < duration) {
                requestAnimationFrame(animation);
            }
        }

        function easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }

        requestAnimationFrame(animation);
    }
})();
